export const GoBackSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#D9D9D9" />
    <path
      d="M19 23.9201L12.48 17.4001C11.71 16.6301 11.71 15.3701 12.48 14.6001L19 8.08008"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
